<template>
    <template v-for="catalog in this.listCatalogs" :key="catalog.ICatalogo">
        <BackorderCart 
            v-if="catalog.IdCatalogo in this.listaCataloghiArticoli" 
            :catalog="catalog" 
            :listaArticoli="this.listaCataloghiArticoli[catalog.IdCatalogo]"
            @UpdateCart = "this.resetCataloghiArticoli"
        />
    </template>
</template>
<script>
import BackorderCart from "@/components/BackorderCart.vue"
export default{
    name: "BackorderCatalogCartCont",
    components:{
        BackorderCart
    },
    emits:['UpdateTotalCart'],
    data(){
        return {
            listCatalogs: [],
            listaCataloghiArticoli: []
        }
    },
    props: {
        catalogs: Array
    },
    watch:{
        catalogs: function(newValue){
            this.listCatalogs = newValue
        }
    },
    methods: {
        setListaCatalghiArticoli: function(){
            if(this.$store.getters.getCarrello){
                let righeCarrelloAll = this.$store.getters.getCarrello.Righe;
                if(righeCarrelloAll){
                    let righeCarrello = JSON.parse(JSON.stringify(righeCarrelloAll.filter(x => x.IsBackorder == 1)));
                    if(righeCarrello){
                        righeCarrello.forEach(articolo => {
                            if(!(articolo.Catalogo in this.listaCataloghiArticoli)){
                                this.listaCataloghiArticoli[articolo.Catalogo] = [];
                            }
                            this.listaCataloghiArticoli[articolo.Catalogo].push(articolo);
                        });
                    }
                }
            }
        },
        resetCataloghiArticoli: function(){
            this.listaCataloghiArticoli = [];
            this.setListaCatalghiArticoli();
            this.$emit("UpdateTotalCart");
        }
    },
    mounted: function(){
        if(this.listCatalogs.length == 0){
            this.listCatalogs = this.$store.getters.getCatalogs;
        }
        this.setListaCatalghiArticoli();
    }
}
</script>